import { IS_ACTIVE } from '../constants';

export default function dropdown(element: string): void {
    const elm: HTMLElement | null = document.querySelector(element);

    elm?.addEventListener('click', (e: Event) => {
        elm.classList.toggle(IS_ACTIVE);
    });
}
